import { api } from '@/shared/lib/api'
import { useQuery } from '@tanstack/react-query'

export const useGetFolderTree = (id: string, enabled: boolean = true) => {
    return useQuery({
        queryKey: ['folder-tree', id],
        queryFn: () => api.folder.getFolderTree(id),
        enabled: enabled && !!id,
        meta: {
            skipGlobalErrorHandler: true,
        },
    })
}
